import React from "react";

export default class PageHeader extends React.Component {
    render() {
        return (
            <div>
                <div className="header border-bot">
                    <img className="logo" src="https://ss7.vzw.com/is/image/VerizonWireless/vzw-logo-156-130-c?$pngalpha$&wid=156&hei=35"/>
                    <div>{this.props.title}</div>
                </div>
                <div className="header-spacer"></div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/js/components/PageHeader.js